module.exports = ".center {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n"